export const selectPayrollLoading = (state) =>
  state.processPayroll?.loading || false;
export const selectPayrollError = (state) =>
  state.processPayroll?.error || null;
export const selectProcessInfo = (state) =>
  state.processPayroll?.processInfo || null;
export const selectPayrollSummary = (state) =>
  state.processPayroll?.summary || null;
export const selectPayrollTransactions = (state) =>
  state.processPayroll?.transactions || [];
export const selectPayrollPagination = (state) =>
  state.processPayroll?.pagination || {};
export const selectUpdatingStatus = (state) =>
  state.processPayroll?.updatingStatus || false;
export const selectPayslip = (state) => state.processPayroll?.payslip || null;
export const selectPayslipLoading = (state) =>
  state.processPayroll?.payslipLoading || false;
